import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import type { RawRuleOf } from '@casl/ability';
import type { CompanySettingsAccessContext } from '@/abilities/companySettings/context';
import { COMPANY_SETTINGS_DESTINATION, type CompanySettingsAbility } from '@/abilities/companySettings/vocabulary';

export const companySettingsUsersRules = ({
  isAdmin,
}: Pick<CompanySettingsAccessContext, 'isAdmin'>): RawRuleOf<CompanySettingsAbility>[] => {
  const { can, rules } = new AbilityBuilder<CompanySettingsAbility>(createMongoAbility);
  if (isAdmin) can(['see', 'open'], COMPANY_SETTINGS_DESTINATION, { destination: 'users' });
  return rules;
};
